import styled from 'vue-styled-components'
import size from '@/components/kit/size'

// use <absolute :top="'0'" :bottom="'0px'" :left="'0px'" :right="'0'"></absolute>
// or <absolute :top="'space-m'" :bottom="'0px'" :left="'0px'" :right="'space-m'"></absolute>

const componentProps = {
  top: {
    type: String,
    default: 'auto'
  },
  bottom: {
    type: String,
    default: 'auto'
  },
  left: {
    type: String,
    default: 'auto'
  },
  right: {
    type: String,
    default: 'auto'
  }
}

const AbsoluteDiv = styled('div', componentProps)`
  position: absolute;
  top: ${(props) => size.knownSize(props.top)}px;
  bottom: ${(props) =>
    size.knownSize(props.bottom) +
    (size.knownSize(props.bottom) !== props.bottom ? 'px' : '')};
  left: ${(props) =>
    size.knownSize(props.left) +
    (size.knownSize(props.left) !== props.left ? 'px' : '')};
  right: ${(props) =>
    size.knownSize(props.right) +
    (size.knownSize(props.right) !== props.right ? 'px' : '')};
`

export default {
  props: {
    top: String,
    bottom: String,
    left: String,
    right: String
  },
  render(h) {
    return (
      <AbsoluteDiv
        top={this.top}
        bottom={this.bottom}
        left={this.left}
        right={this.right}
      >
        {this.$slots.default}
      </AbsoluteDiv>
    )
  }
}
